"use client";
import React from "react";
import { ShieldCheck, ArrowRight } from "lucide-react";

export default function PrivacyStatementPage() {
  const appTitle = process.env.NEXT_PUBLIC_APP_TITLE;

  return (
    <div className="lg:py-7 bg-gray-50">
      <div className="max-w-4xl mx-auto py-10 sm:py-16 lg:py-12 px-4 sm:px-6 lg:px-8 bg-white shadow-lg lg:rounded-xl">
        <div className="mb-8 border-b pb-4 border-gray-200">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-2 flex items-center">
            <ShieldCheck className="w-7 h-7 mr-3 text-primary-600 hidden sm:inline" />
            Privacy Statement
          </h1>
        </div>
        
        <p className="text-base sm:text-lg text-gray-700 mb-8 lg:mb-12 leading-relaxed"> 
          We value your privacy and are committed to protecting your personal information. This statement explains how we collect, use, and safeguard your data when you use <span className="font-semibold text-primary-600">{appTitle}</span>.
        </p>

        <div className="bg-blue-50 p-6 sm:p-8 rounded-lg mb-10 border border-blue-100">
            <h2 className="text-xl font-bold text-blue-800 mb-4 flex items-center">
                <ShieldCheck className="w-5 h-5 mr-2" />
                Our Commitment to You
            </h2>
            <ul className="list-disc pl-6 text-base text-gray-700 space-y-3">
              <li className="pl-1">We only collect information necessary to provide our services.</li>
              <li className="pl-1">Your data is never sold to third parties.</li>
              <li className="pl-1">We use industry-standard security measures to protect your information.</li>
              <li className="pl-1">You can contact us anytime to request data deletion or updates.</li>
            </ul>
        </div>
        
        <div className="mt-10 pt-4 border-t border-gray-200">
            <p className="text-base sm:text-lg text-gray-700 font-medium">
                For more comprehensive details on data handling, legal terms, and your rights, 
                <span className="block sm:inline mt-2 sm:mt-0">
                    <a 
                        href="/privacy-policy" 
                        className="flex space-x-1 text-primary-600 font-semibold hover:text-primary-700 underline transition-colors w-max mx-auto sm:mx-0"
                    >
                        <span>Read our full Privacy Policy</span>
                        <ArrowRight className="w-4 h-4"/>
                    </a>
                </span>
            </p>
        </div>
      </div>
    </div>
  );
}